import { IRegion } from '../../../../../../types/regions';

const MAX_RESULTS_COUNT = 4;

export const getRegionsByText = (text: string, regions: IRegion[]) => {
  const results = [];

  for (let i = 0; i < regions.length; i++) {
    if (regions[i].name.toLowerCase().indexOf(text.toLowerCase()) > -1) {
      results.push(regions[i]);
    }

    if (results.length === MAX_RESULTS_COUNT) {
      break;
    }
  }

  results.sort((first: IRegion, second: IRegion) => {
    const firstNameLower = first.name.toLowerCase();
    const secondNameLower = second.name.toLowerCase();
    const textLower = text.toLowerCase();

    const firstStartsWith = firstNameLower.startsWith(textLower);
    const secondStartsWith = secondNameLower.startsWith(textLower);

    // Сначала идут регионы, название которых начинается с text.
    if (firstStartsWith && !secondStartsWith) {
      return -1;
    }
    if (!firstStartsWith && secondStartsWith) {
      return 1;
    }

    // Далее идут регионы, название которых просто содержит text.
    const firstIncludes = firstNameLower.includes(textLower);
    const secondIncludes = secondNameLower.includes(textLower);

    if (firstIncludes && !secondIncludes) {
      return -1;
    }
    if (!firstIncludes && secondIncludes) {
      return 1;
    }

    return 0;
  });

  return results;
};
